<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineEmits(['save', 'discard', 'stay']);
const { t } = useI18n();
const dialogRef = ref(null);

defineExpose({
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('ARROWS_AI.UNSAVED.TITLE')"
    :description="t('ARROWS_AI.UNSAVED.DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="$emit('stay')"
  >
    <template #footer>
      <div class="flex items-center justify-between w-full gap-3">
        <Button
          type="button"
          variant="faded"
          color="slate"
          class="w-full"
          :label="t('ARROWS_AI.UNSAVED.NO')"
          @click="$emit('discard')"
        />
        <Button
          type="button"
          class="w-full"
          :label="t('ARROWS_AI.UNSAVED.YES')"
          @click="$emit('save')"
        />
      </div>
    </template>
  </Dialog>
</template>
